import useDesign from 'packages/pages/design/hooks/useDesign';
import useCommonRenditionProfiles from 'packages/hooks/useRenditionProfiles';

const useRenditionProfiles = () => {
    const { creativeType } = useDesign();

    return useCommonRenditionProfiles({ creativeType });
};

export default useRenditionProfiles;
